/**
 * ISHAB THEME - Main JavaScript
 * Arabic Card Game Theme
 * Handles navigation, animations, and interactive features
 */

(function () {
  'use strict';

  /**
   * Navigation scroll effect
   */
  function initializeNavigation() {
    const nav = document.getElementById('nav');
    if (!nav) return;

    window.addEventListener(
      'scroll',
      () => {
        nav.classList.toggle('scrolled', window.scrollY > 50);
      },
      { passive: true }
    );
  }

  /**
   * Intersection Observer for scroll reveal animations
   */
  function initializeScrollReveal() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            // Optionally unobserve after revealing
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    // Observe elements with animation classes
    const elementsToObserve = document.querySelectorAll(
      '.step, .card-type, .scoring-row'
    );
    elementsToObserve.forEach((el) => observer.observe(el));
  }

  /**
   * Smooth scroll anchor links
   */
  function initializeSmoothScrollLinks() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        e.preventDefault();
        const target = document.querySelector(href);

        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });

          // Update browser history
          window.history.pushState(null, null, href);
        }
      });
    });
  }

  /**
   * Initialize all interactive features
   */
  function init() {
    initializeNavigation();
    initializeScrollReveal();
    initializeSmoothScrollLinks();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();